<template>
  <v-flex xs12>
    <v-card elevation="15">
      <v-card-title primary-title class="h3">
        Product Information
      </v-card-title>       
      <v-card-text>
        <v-form ref="form"
                v-model="valid"
                lazy-validation
        >
          <v-container>           
            <v-row>
              <v-col cols="4">
                <v-select
                  v-model="selectedPublisher"
                  label="Välj Titel"
                  :items="publishers"
                  item-text="name"
                  item-value="value"
                  @change="publisherSelected"
                />
                <v-select v-if="paperEditions.length > 0"        
                          v-model="selectedEdition"
                          label="Välj Utgåva"
                          :items="paperEditions"
                          item-text="description"
                          return-object        
                          @change="editionSelected"
                />         
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-dialog
                  ref="dialog"
                  v-model="dateModal"
                  :return-value.sync="product.deliveryDate"
                  persistent
                  width="290px"                                    
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="product.deliveryDate"
                      label="Datum"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="product.deliveryDate"
                    scrollable
                    locale="sv-se"
                    :first-day-of-week="1"                    
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="dateModal = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(product.deliveryDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>             
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="product.articleId" label="Artikel kod" />              
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="product.productCode" label="Produkt kod" />              
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="product.accountCode" label="Konto" />              
              </v-col>
            </v-row>            
          </v-container> 
          <v-btn
            :disabled="!valid"
            color="success"
            class="mr-4"
            @click="save"
          >
            <span v-if="product.id == 0">Spara</span>
            <span v-else>Uppdatera</span>            
          </v-btn>
          <v-btn 
            color="warning"
            @click="resetForm"
          >
            Nollställ
          </v-btn> 
        </v-form>        
      </v-card-text>
      <v-card-text>
        <v-card-title>Produkt information</v-card-title>
        <v-container v-if="loading">
          <v-overlay>
            <v-row class="fill-height"
                   align-content="center"
                   justify="center"
            >
              <v-col
                class="text-subtitle-1 text-center"
                cols="12"
              >
                Hämtar data...
              </v-col>
              <v-col cols="12">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                />
              </v-col>
            </v-row>        
          </v-overlay>
        </v-container>                     
 
        <v-container v-else-if="!loading">                                    
          <v-container v-for="(productProvider,id) in productList" :key="id">                     
            <div class="text-h5">
              {{ productProvider.paper }}        
            </div>
            <v-simple-table>
              <template>
                <thead>
                  <tr>
                    <th class="text-left">
                      Title
                    </th>
                    <th class="text-left">
                      Utgåva
                    </th>
                    <th class="text-left">
                      Datum
                    </th>
                    <th class="text-left">
                      Konto
                    </th>
                    <th class="text-left">
                      Product kod
                    </th>
                    <th class="text-left">
                      Article id
                    </th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item,idx) in productProvider.products"
                    :key="item.id"
                    @click="edit(id,idx)"
                  >
                    <td>{{ item.titleId }}</td>
                    <td>{{ getEdition(id,item.editionId) }}</td>                
                    <!-- <td>{{ item.editionId }}</td> -->
                    <td v-if="item.deliveryDate === undefined" />
                    <td v-else>
                      {{ item.deliveryDate |toLocalDate }}
                    </td>
                    <td>{{ item.accountCode }}</td>
                    <td>{{ item.productCode }}</td>
                    <td>{{ item.articleId }}</td>
                    <td>
                      <v-btn x-small icon
                             @click.stop="remove(id,idx)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>   
          </v-container>  
        </v-container>        
      </v-card-text>
    </v-card>
  </v-flex>
</template>   
<script>
import adminApi from '@/backend/adminapi'
import log from '@/logger'
import adminapi from '../../backend/adminapi'
export default {    
  name: 'Products',
  components: { },

  data() {
    return {
      products: [],
      papers:[],
      loading: true,
      dateModal:false,
      valid: true,      
      publishers:[
        {name:'Välj tidning', value:-1},
        {name:'Aftonbladet', value:1},
        {name:'Expressen', value:2}],
      selectedPublisher: null,
      selectedEdition: {},
      paperEditions:[],
      product:{
            id:0,
            titleId:0,
            editionId:0,
            deliveryDate:undefined,
            productCode:'',
            accountCode:'',
            articleId:''            
        },
    }
  },
  computed:{
    
    productList(){
      return this.products
    },
  
  },
  mounted() {
    this.loadData()
  },
  methods: {   
    loadData() {
      adminApi.adminGetDailyProducts(1)
       .then((resp) => {
          this.papers.splice(0,0,resp.data)
          log.debug('Paper editions Aftonbladet:' + resp.data)
          adminApi.adminGetDailyProducts(2)
          .then((resp) => {
              this.papers.splice(1,0,resp.data)
              log.debug('Paper editions Expressen:' + resp.data)              
            })
        })
        .catch((error) => {
          self.loading = false
          log.debug('Error - Getting papers file:', error)
        })
        this.loadProductInformation()
    },
    loadProductInformation(){
      adminApi
        .adminGetProductInformations(0)
        .then((resp) => {
          log.debug('Products Aftonbladet:' + resp.data)
           this.products.splice(0,0,resp.data)
           adminApi
            .adminGetProductInformations(1)
            .then((resp) => {
              log.debug('Products Expressen:' + resp.data)
              this.products.splice(1,0,resp.data)
              this.loading = false
            })    
        })
        .catch((error) => {
          self.loading = false
          log.debug('Error - Getting products:', error)
        })
    },
    getEdition(id,editionId){
      var edition = this.papers[id].find((item)=> item.editionId == editionId)
      if(edition === undefined)
      {
        return editionId
      }
      else{
        return edition.description
      }
      
    } ,
    validate () {
      this.$refs.form.validate()        
      },
    resetForm(){        
      this.product.id=0
      this.product.titleId=0
      this.product.editionId=0
      this.product.deliveryDate=undefined
      this.product.productCode=''
      this.product.accountCode=''
      this.product.articleId=''    
      this.selectedPublisher=null,
      this.selectedEdition={}
      
    },
    edit(id,idx){      
      var product = this.products[id].products.at(idx)
      log.debug(product)
      this.product = Object.assign({}, product)
      this.product.deliveryDate=this.$options.filters.toLocalDate(product.deliveryDate)
      this.product.productCode = product.productCode
      this.product.accountCode= product.accountCode
      this.product.titleId = product.titleId
      this.product.editionId= product.editionId
      this.product.articleId = product.articleId
      let valueid = product.titleId
      if(valueid === 16){
        valueid = 1
      }
      else if(valueid === 32){
        valueid = 2
      }

      var index = this.publishers.findIndex(obj => obj.value === valueid)
      if(index !== -1 ){
        this.selectedPublisher = this.publishers[index].value 
        this.publisherSelected()
      }
      
    },
    remove(id,idx){      
      var product = this.products[id].products.at(idx)
      var self = this
      
      var prd ={
        id:product.id,
        deliveryDate:product.deliveryDate,
        productCode: product.productCode,
        accountCode: product.accountCode,
        titleId : product.titleId,
        editionId : product.editionId,
        articleId: product.articleId
      }
      log.debug(prd)
      adminapi.deleteProductInformation(prd).then(()=>{
          self.loading = false          
          let rmd = self.products[id].products.splice(idx,1)
          log.debug('Deleted:', rmd)
          this.resetForm()
          //this.$emit('saved', paper)
      })
        .catch(error => {
          self.loading = false
          log.debug('Errors:', error)
        })        
    },
    save(){
     this.validate()
      log.debug('Save product ',this.product)
      var self = this
      var update = false
      self.loading = true
      
      var prd ={
        deliveryDate:this.product.deliveryDate,
        productCode: this.product.productCode,
        accountCode: this.product.accountCode,
        titleId:  this.selectedEdition.titleId,
        editionId: this.selectedEdition.editionId,
        articleId: this.product.articleId        
      }
      
      if(this.product.id > 0){
        prd.id= this.product.id
        prd.titleId = this.selectedEdition.titleId
        if(prd.editionId !==  this.selectedEdition.editionId){
          prd.editionId = this.selectedEdition.editionId
        }
        else{
          prd.editionId = this.product.editionId
        }
        
        
        update = true
      }
           
      adminApi
        .adminSaveProductInformation(prd)
        .then(resp => {
          self.loading = false
          var product = resp.data          
          self.product.id = product.id
          let provider = 0
            if(product.titleId === 2 ||product.titleId === 32 ){
              provider = 1
            }
          if(!update){
            
            self.products[provider].products.push(product)
          }
          else{
            
            var index = this.products[provider].products.findIndex(obj => obj.id === product.id)
            if(index !== -1 ){
              this.products[provider].products[index] = product
            }else{
              log.debug(`Could not find ${product.id} in messages.`)
            }          
          }
          log.debug('Success:',product)                        
        })
        .then(()=>{          
            this.resetForm()          
        })
        .catch(error => {
          self.loading = false
          log.debug('Errors:', error)
        })        
    },  
    publisherSelected(){
      var self = this
        if(this.selectedPublisher > 0){
          adminApi.adminGetDailyProducts(this.selectedPublisher)
            .then(resp=>{
                this.paperEditions = resp.data
                log.debug('Editions :',resp.data)
                if(self.product.editionId !== undefined && self.product.editionId>0 ){
                  self.selectedEdition =this.paperEditions.find((edition) => edition.editionId === self.product.editionId )                 
                }
            })
        }
    },
    editionSelected(){
      
        if(this.product.articleId === '' || this.product.articleId  === undefined){
          
          this.product.articleId = this.selectedEdition.code
          
        }
    }
      
  },
}
</script>

<style></style>
